var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full relative"},[(_vm.renderer)?_c('O3D',{},[_c('O3D',{attrs:{"py":-10.5}},[_c('CamControl',{on:{"ready":function($event){_vm.isReady = true}}})],1),_c('DanceGUI'),_c('DanceLayout')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }